import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/subscription-modal-icon.svg")